import actionTypes from 'constants/actionTypes'
import defaultsDeep from 'lodash/defaultsDeep'

interface ForgotPasswordState {
  isFetching: boolean
}

interface ForgotPasswordAction {
  type?: string
}

const initialState: ForgotPasswordState = {
  isFetching: false,
}

export default (state: ForgotPasswordState = initialState, action: ForgotPasswordAction): ForgotPasswordState => {
  if (action.type === actionTypes.AUTH.FORGOT_PASSWORD.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.FORGOT_PASSWORD.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.FORGOT_PASSWORD.FAIL) {
    return defaultsDeep(
      {
        isFetching: false
      },
      state
    )
  }
  return state
}
